export default __webpack_public_path__ + "static/media2-cb1710f5f00bb12cf467964ee55554b4.jpg";